import { Snackbar } from "@octopusdeploy/design-system-components";
import React from "react";
export default function TaskQueueUpdatedSnackbar({ open, onClose }: {
    open: boolean;
    onClose: () => void;
}) {
    return <Snackbar open={open} content={"Task queue updated"} autoHideDuration={3500} onClose={onClose} textAlign={"center"}/>;
}
